<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle d-block">Perfil</span>
        <h3 class="page-title d-inline">Editar</h3>
      </d-col>
    </d-row>

    <!-- Content -->
    <d-row>
      <d-col lg="12">
        <commercial-form :commercial="commercial" ref="commercialForm"/>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import CommercialForm from '_modules/commercial/components/CommercialForm.vue';
import { MODEL, _LOAD_MODEL_ } from '../components/CommercialModel';

export default {
  name: 'commercial-edit',
  components: {
    CommercialForm,
  },
  computed: {
    commercial() {
      const { commercial } = this.$store.state.commercial;
      if (commercial) {
        Events.$emit(_LOAD_MODEL_, commercial);
        return commercial;
      }
      return MODEL;
    },
    isAdmin() {
      const { isAdmin } = this.$store.state.user;
      return isAdmin;
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'checkAdmin',
      'activeAlert',
      'getCommercial',
    ]),
    save() {
      this.$refs.commercialForm.save();
    },
  },
  mounted() {
    this.checkAdmin();
    return this.getCommercial(null);
  },
};
</script>

